import Profile from './../models/Profile';
import Base from './Base';

export default class Profiles extends Base {
    get models() {
        const collection = this.data.map(item => new Profile(item));
        collection.collection = this;

        return collection;
    }
}
